import { memo, useEffect } from 'react';
import { useSessionRestore } from 'js/hooks/auth';
import { useReferrer } from 'js/hooks/useReferrer';
import { useNormalizeUrl } from 'js/hooks/language';
import { useAffiliate } from 'js/hooks/useAffiliate';
import { useTranslationsService } from 'js/hooks/i18n';
import { useGetJackpots } from 'js/hooks/useGetJackpots';
import { useGetForms } from 'js/components/common/ChangeForm/hooks';
import { useLiveGamesIntegration } from 'js/hooks/useLiveGamesIntegration';
import { useInitWidgets } from 'js/components/system/CommunicationWidgets/hooks';
import { useTimeIsFlyingNotification } from 'js/hooks/useTimeIsFlyingNotification';
import { useAgeVerificationPopup } from 'js/components/popups/AgeVerificationPopup';
import { useDataVerificationStatusPopup } from 'js/components/popups/DataVerificationStatusPopup';
import { useBiometricsHandler, useNativeCookieConsent, useNativeLogoutTrigger } from 'js/hooks/native';
import { useJumioVerifyStatusPopup, useJumioVerifyPopup } from 'js/components/popups/JumioVerifyPopup';
import { useLegacyModelSync, useBalanceAlert, useGetToastTimeoutValue, useOnAgeVerificationStatusChange } from 'js/hooks/user';

import * as hooks from './hooks';

export const AppPostInit = memo(() => {
    const getForms = useGetForms();

    // move it to ChangeForm component after deleting registration
    useEffect(() => {
        getForms();
    }, [getForms]);

    // at this point you should already be fetched app and user
    // notification subscriptions should be the first in the list
    // in order to handle push triggers added below
    hooks.useNotificationSubscriptions();
    useTimeIsFlyingNotification();
    useReferrer();
    useAffiliate();
    useGetJackpots();
    useInitWidgets();
    useNormalizeUrl();
    useBalanceAlert();
    useSessionRestore();
    useLegacyModelSync();
    hooks.usePromoCode();
    useJumioVerifyPopup();
    useBiometricsHandler();
    useNativeLogoutTrigger();
    useNativeCookieConsent();
    useTranslationsService();
    useAgeVerificationPopup();
    useGetToastTimeoutValue();
    hooks.useUnblockAccount();
    hooks.useThemeNameClass();
    useJumioVerifyStatusPopup();
    hooks.useResetFavoriteGames();
    hooks.useSetupCookiesGroups();
    hooks.useLegacyLoginHandler();
    hooks.useLegacyLogoutHandler();
    hooks.useLegacyRedirectHandler();
    hooks.useLegacyLanguageSelector();
    hooks.useLegacyGameLaunchHandler();
    hooks.useLegacyCoreNavigateListener();
    hooks.useLegacyQuickDepositListener();
    hooks.useLegacyBackButtonShowListener();
    hooks.useLegacyTrackGameLaunchListener();
    hooks.useLegacyEmailVerificationTrigger();
    hooks.useDispatchPopupRendered();
    useLiveGamesIntegration();
    useDataVerificationStatusPopup();
    useOnAgeVerificationStatusChange();
    hooks.useSidebar();
    hooks.useGlobalPopupOpenListener();
    // uncomment after menu & deposit button are on react and quick-deposit.service is removed
    // hooks.useQuickDepositAvailability();

    return null;
});
